import { render, staticRenderFns } from "./StudentCoursesList.vue?vue&type=template&id=191bf60c&scoped=true&"
import script from "./StudentCoursesList.vue?vue&type=script&lang=js&"
export * from "./StudentCoursesList.vue?vue&type=script&lang=js&"
import style0 from "./StudentCoursesList.vue?vue&type=style&index=0&id=191bf60c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191bf60c",
  null
  
)

export default component.exports